export const createExcerpt = (value: string, length: number = 100) => {
  if (value.length <= length) {
    return value;
  }

  const trimmed = value.substring(0, length);

  return trimmed.substring(0, Math.min(trimmed.length, trimmed.lastIndexOf(' '))) + '...';
};
